export const ALL = {
  '1': 'All',
  '2': 'All',
  '3': 'Alle',
  '4': 'Toutes nos Cat\u00E9gories',
  '5': '\u5168\u3066',
  '6': 'All',
  '8': 'Tutte le Categorie',
  '9': 'Todos los Departamentos',
  '10': 'All',
  '11': 'Todos los Departamentos',
  '12': 'Todos os Departamentos',
};

export const SEARCH_DEALS = {
  '1': 'Search Deals',
  '2': 'Search Deals',
  '3': 'Angebote Suchen',
  '4': 'Rechercher des offres',
  '5': '\u30BB\u30FC\u30EB\u3092\u691C\u7D22',
  '6': 'Search Deals',
  '8': 'Cerca Offerte',
  '9': 'Buscar Ofertas',
  '10': 'Search Deals',
  '11': 'Buscar Ofertas',
  '12': 'Buscar Ofertas',
};

export const SEARCH = {
  '1': 'Search',
  '2': 'Search',
  '3': 'Suchen',
  '4': 'Rechercher',
  '5': '\u691C\u7D22',
  '6': 'Search',
  '8': 'Cerca',
  '9': 'Buscar',
  '10': 'Search',
  '11': 'Buscar',
  '12': 'Buscar',
};

export const SORT_BY = {
  '1': 'Sort By',
  '2': 'Sort By',
  '3': 'Sortieren Nach',
  '4': 'Trier par',
  '5': '\u4E26\u3079\u66FF\u3048',
  '6': 'Sort By',
  '8': 'Ordina per',
  '9': 'Ordenar por',
  '10': 'Sort By',
  '11': 'Ordenar Por',
  '12': 'Ordenar Por',
};

export const ESTIMATED_SAVINGS = {
  '1': 'Estimated Savings',
  '2': 'Estimated Savings',
  '3': 'Gesch\u00E4tzte Einsparung',
  '4': '\u00C9conomies estim\u00E9es',
  '5': '\u63A8\u5B9A\u5272\u5F15\u7387',
  '6': 'Estimated Savings',
  '8': 'Risparmio stimato',
  '9': 'Ahorro estimado',
  '10': 'Estimated Savings',
  '11': 'Ahorro Estimado',
  '12': 'Economia Estimada',
};

export const ESTIMATED_PRICE_DIFFERENCE = {
  '1': 'Estimated Price Difference',
  '2': 'Estimated Price Difference',
  '3': 'Gesch\u00E4tzte Preisdifferenz',
  '4': 'Diff\u00E9rence de prix estim\u00E9e',
  '5': '\u63A8\u5B9A\u4FA1\u683C\u5DEE',
  '6': 'Estimated Price Difference',
  '8': 'Differenza di prezzo stimata',
  '9': 'Diferencia de precio estimada',
  '10': 'Estimated Price Difference',
  '11': 'Diferencia de Precio Estimada',
  '12': 'Diferen\u00E7a de Pre\u00E7o Estimada',
};

export const USED_PRICE = {
  '1': 'Used Price',
  '2': 'Used Price',
  '3': 'Gebrauchter Preis',
  '4': 'Prix d\u2019occasion',
  '5': '\u4E2D\u53E4\u4FA1\u683C',
  '6': 'Used Price',
  '8': 'Prezzo usato',
  '9': 'Precio usado',
  '10': 'Used Price',
  '11': 'Precio Usado',
  '12': 'Pre\u00E7o Usado',
};

export const NEW_PRICE = {
  '1': 'New Price',
  '2': 'New Price',
  '3': 'Neuer Preis',
  '4': 'Prix neuf',
  '5': '\u65B0\u54C1\u4FA1\u683C',
  '6': 'New Price',
  '8': 'Prezzo nuovo',
  '9': 'Precio nuevo',
  '10': 'New Price',
  '11': 'Precio Nuevo',
  '12': 'Pre\u00E7o Novo',
};

export const PRICE = {
  '1': 'Price',
  '2': 'Price',
  '3': 'Preis',
  '4': 'Prix',
  '5': '\u4FA1\u683C',
  '6': 'Price',
  '8': 'Prezzo',
  '9': 'Precio',
  '10': 'Price',
  '11': 'Precio',
  '12': 'Pre\u00E7o',
};

export const DEAL_RATING = {
  '1': 'Deal Rating',
  '2': 'Deal Rating',
  '3': 'Bewertung der Angebote',
  '4': 'Note de l\u2019offre',
  '5': '\u30C7\u30A3\u30FC\u30EB\u8A55\u4FA1',
  '6': 'Deal Rating',
  '8': 'Valutazione offerta',
  '9': 'Valoraci\u00F3n de oferta',
  '10': 'Deal Rating',
  '11': 'Deal Rating',
  '12': 'Deal Rating',
};

export const MOST_RECENT = {
  '1': 'Most Recent Change',
  '2': 'Most Recent Change',
  '3': 'Neueste \u00C4nderung',
  '4': 'Modification la plus r\u00E9cente',
  '5': '\u6700\u65B0\u306E\u5909\u66F4',
  '6': 'Most Recent Change',
  '8': 'Modifica pi\u00F9 recente',
  '9': 'Cambio m\u00E1s reciente',
  '10': 'Most Recent Change',
  '11': 'Cambio m\u00E1s reciente',
  '12': 'Altera\u00E7\u00E3o mais recente',
};

export const CATEGORIES = {
  '1': 'Categories',
  '2': 'Categories',
  '3': 'Kategorien',
  '4': 'Cat\u00E9gories',
  '5': '\u30AB\u30C6\u30B4\u30EA\u30FC',
  '6': 'Categories',
  '8': 'Categorie',
  '9': 'Departamentos',
  '10': 'Categories',
  '11': 'Departamentos',
  '12': 'Categorias',
};

export const SEARCH_AND_BROWSE = {
  '1': 'Search Amazon Warehouse deals.',
  '2': 'Search Amazon Warehouse deals.',
  '3': 'Suchen und durchsuchen Sie Tausende gebrauchter Artikel, die bei Amazon verkauft werden.',
  '4': 'Recherchez des offres Amazon Warehouse.',
  '5': 'Amazon\u30A2\u30A6\u30C8\u30EC\u30C3\u30C8\u306E\u304A\u8CB7\u3044\u5F97\u54C1\u3092\u691C\u7D22\u3002',
  '6': 'Search Amazon Warehouse deals.',
  '8': 'Cerca offerte Amazon Warehouse.',
  '9': 'Busca ofertas de Amazon Warehouse.',
  '10': 'Search Amazon Warehouse deals.',
  '11': 'Busca ofertas de Amazon Warehouse.',
  '12': 'Pesquise ofertas do Amazon Warehouse.',
};

export const END_OF_RESULTS = {
  '1': 'End of results',
  '2': 'End of results',
  '3': 'Ende der Ergebnisse',
  '4': 'Fin des r\u00E9sultats',
  '5': '\u7D50\u679C\u306E\u7D42\u308F\u308A',
  '6': 'End of results',
  '8': 'Fine dei risultati',
  '9': 'Fin de los resultados',
  '10': 'End of results',
  '11': 'Fin de los resultados',
  '12': 'Fim dos resultados',
};

export const SEARCH_AMAZON_WAREHOUSE_DEALS = {
  '1': 'Search Amazon Warehouse deals',
  '2': 'Search Amazon Warehouse deals',
  '3': 'Angebote Suchen im Amazon Warehouse',
  '4': 'Rechercher des offres Amazon Warehouse',
  '5': 'Amazon\u30A2\u30A6\u30C8\u30EC\u30C3\u30C8\u306E\u304A\u8CB7\u3044\u5F97\u54C1\u3092\u691C\u7D22',
  '6': 'Search Amazon Warehouse deals',
  '8': 'Cerca offerte Amazon Warehouse',
  '9': 'Busca ofertas de Amazon Warehouse',
  '10': 'Search Amazon Warehouse deals',
  '11': 'Busca ofertas de Amazon Warehouse',
  '12': 'Pesquise ofertas do Amazon Warehouse',
};
